import { IssueCommentCreate } from "@boark/shared/types/issue-comment-create";
import { IssueCommentUpdate } from "@boark/shared/types/issue-comment-update";
import {
  IssueCommentWithCreatedBy,
  issueCommentWithCreatedBySchema,
} from "@boark/shared/types/issue-comment-with-created-by";
import * as z from "zod";

import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../utils/request";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getIssueComments(
  issueIdentifier: string | number,
): Promise<IssueCommentWithCreatedBy[]> {
  return getRequest(
    `${API_BASE_URL}/issue/${issueIdentifier}/comment`,
    z.array(issueCommentWithCreatedBySchema),
  );
}

export async function createIssueComment(
  issueIdentifier: string | number,
  comment: IssueCommentCreate,
): Promise<IssueCommentWithCreatedBy> {
  return postRequest(
    `${API_BASE_URL}/issue/${issueIdentifier}/comment`,
    comment,
    issueCommentWithCreatedBySchema,
  );
}

export async function updateIssueComment(
  issueIdentifier: string | number,
  commentId: string,
  comment: IssueCommentUpdate,
): Promise<IssueCommentWithCreatedBy> {
  return putRequest(
    `${API_BASE_URL}/issue/${issueIdentifier}/comment/${encodeURIComponent(commentId)}`,
    comment,
    issueCommentWithCreatedBySchema,
  );
}

export async function deleteIssueComment(
  issueIdentifier: string | number,
  commentId: string,
): Promise<void> {
  return deleteRequest(
    `${API_BASE_URL}/issue/${issueIdentifier}/comment/${encodeURIComponent(commentId)}`,
  );
}
